import { getFileExport } from 'entities/Files/api';
import { showErrorNotification } from 'shared/helpers/showErrorNotification';

export const downloadFile = async ({ fileId, type }: { fileId: string[]; type: string }) => {
	for (let i = 0; i < fileId.length; i++) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		await getFileExport({ fileId: fileId[i], type })
			.then((response: any) => {
				downloadFileOnPC(response);
			})
			.catch((error) => {
				showErrorNotification(error);
			});
	}
};

// fallbackFilename is used when Content-Disposition is missing or not exposed via CORS
export const downloadFileOnPC = (response: any, fallbackFilename = 'filename.json') => {
	const disposition = response.headers.get('content-disposition');
	let filename = fallbackFilename;
	if (disposition && disposition.indexOf('attachment') !== -1) {
		const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
		const matches = filenameRegex.exec(disposition);
		if (matches != null && matches[1]) {
			filename = matches[1].replace(/['"]/g, '');
		}
	}
	const url = window.URL.createObjectURL(response.data);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	a.remove();
};
